<template>
  <div class="menu">
    <div v-if="isMobile()">
      <b-modal
        id="modal-1"
        ref="myModal"
        hide-footer
        hide-header
        centered
        v-show="show"
        @show-me="show = true"
        @hide-me="show = false"
        class="modalFull"
      >
        <b-row class="Downloadbox">
          <b-col>
            <img
              class="dLoadImg"
              src="https://ocs-sport.ams3.cdn.digitaloceanspaces.com/tartanprotour/2020/07/TartanTour_LOGO_03-1.png"
            />
            <h2 class="dLoad">
              Download The Tartan Pro Tour App
            </h2>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" class="downloadLinks">
            <a
              :href="config.VUE_APP_GOOGLE_PLAY"
              target="_blank"
              rel="noopener"
            >
              <b-img
                class="appStore"
                src="https://ocs-sport.ams3.cdn.digitaloceanspaces.com/tartanprotour/2021/03/Mask-Group-4.png"
              ></b-img>
            </a>
          </b-col>
          <b-col md="6" class="downloadLinks">
            <a
              :href="config.VUE_APP_APPLE_STORE"
              target="_blank"
              rel="noopener"
            >
              <b-img
                class="appStore"
                src="https://ocs-sport.ams3.cdn.digitaloceanspaces.com/tartanprotour/2021/03/Mask-Group-5.png"
              ></b-img>
            </a>
          </b-col>
        </b-row>
      </b-modal>
    </div>
    <div
      :class="{
        bannerImg:
          this.$route.name === 'home' || this.$route.name === 'contact',
          NonBanner: this.$route.name !== 'home' || this.$route.name !== 'contact',
          contactBanner: this.$route.name == 'contact'
        }"
    >
      <div id="nav">
        <b-navbar type="dark" toggleable="lg" id="topNav">
          <b-navbar-brand to="/">
            <img
              class="logoImg"
              :class="{
                margB:
                  this.$route.name !== 'home' || this.$route.name !== 'contact',
              }"
              src="https://ocs-sport.ams3.cdn.digitaloceanspaces.com/tartanprotour/2020/07/TartanTour_LOGO_03-1.png"
            />
          </b-navbar-brand>
          <b-navbar-toggle
            class="ml-auto"
            type="dark"
            v-b-modal.nav-collapse
          ></b-navbar-toggle>
          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav class="ml-auto">
              <b-nav-item to="/">
                HOME
              </b-nav-item>
              <b-nav-item to="/schedule">
                SCHEDULE
              </b-nav-item>
              <!-- <template v-if="this.okfound == 'Y' && this.course !== null">
                <b-nav-item
                  :to="{
                    name: 'reports',
                    query: {
                      url: currentReport(),
                      id: season,
                      code: course,
                      fTour: true,
                      title: currentTitle(),
                    },
                  }"
                >
                  RESULTS
                </b-nav-item>
              </template> -->
              <b-nav-item to="/oom">
                OOM
              </b-nav-item>
              <b-nav-item to="/news">
                NEWS
              </b-nav-item>
              <b-nav-item to="/contact-us">
                CONTACT US
              </b-nav-item>
              <b-nav-item
                :href="'https://twitter.com/' + config.VUE_APP_TWITTER_NAME"
              >
                <font-awesome-icon
                  class="icon"
                  :icon="['fab', 'twitter-square']"
                />
              </b-nav-item>
              <b-nav-item
                :href="'https://www.instagram.com/' + config.VUE_APP_INSTA_NAME"
              >
                <font-awesome-icon
                  class="icon"
                  :icon="['fab', 'instagram-square']"
                />
              </b-nav-item>
            </b-navbar-nav>
          </b-collapse>
          <b-modal hide-header hide-footer id="nav-collapse">
            <b-button class='closeBtn' @click="$bvModal.hide('nav-collapse')">X</b-button>
            <div class="mobileMenu">
              <div class="menuGroup">
                <b-nav-item to="/" @click="$bvModal.hide('nav-collapse')">
                  HOME
                </b-nav-item>
                <b-nav-item
                  to="/schedule"
                  @click="$bvModal.hide('nav-collapse')"
                >
                  SCHEDULE
                </b-nav-item>
                <template v-if="this.okfound == 'Y' && this.course !== null">
                  <b-nav-item
                    @click="$bvModal.hide('nav-collapse')"
                    :to="{
                      name: 'reports',
                      query: {
                        url: currentReport(),
                        id: season,
                        code: course,
                        fTour: true,
                        title: currentTitle(),
                      },
                    }"
                  >
                    RESULTS
                  </b-nav-item>
                </template>
                <b-nav-item to="/oom" @click="$bvModal.hide('nav-collapse')">
                  OOM
                </b-nav-item>
                <b-nav-item to="/news" @click="$bvModal.hide('nav-collapse')">
                  NEWS
                </b-nav-item>
                <b-nav-item
                  to="/contact-us"
                  @click="$bvModal.hide('nav-collapse')"
                  class="cont"
                >
                  CONTACT US
                </b-nav-item>
                <b-nav-item
                  :href="'https://twitter.com/' + config.VUE_APP_TWITTER_NAME"
                >
                  <font-awesome-icon
                    id="twit"
                    class="icon"
                    :icon="['fab', 'twitter-square']"
                  />
                </b-nav-item>
                <b-nav-item
                  :href="
                    'https://www.instagram.com/' + config.VUE_APP_INSTA_NAME
                  "
                >
                  <font-awesome-icon
                    id="insta"
                    class="icon fa-gradient"
                    :icon="['fab', 'instagram-square']"
                  />
                </b-nav-item>
              </div>
            </div>
          </b-modal>
        </b-navbar>
      </div>
      <template v-if="this.$route.name === 'home'">
        <div class="bannerTitle">
          <h1>
            <!-- The development tour for male and female golfers, -->
            {{homeSectionData.first_line_text}}
            <br />
            <!-- based in Scotland -->
            {{homeSectionData.second_line_text}}
            <br />
          </h1>
          <h1 class="homeGolf">
            <!-- - The Home of Golf -->
            {{homeSectionData.slogan}}
          </h1>
          <!-- <b-button>JOIN TODAY</b-button> -->
          <b-button :to="homeSectionData.button_link">JOIN TODAY..</b-button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import apiCall from "@/services/api.js";
export default {
  name: "Menu",
  props: ["route", "config"],
  data() {
    return {
      menueLink: "menuLink",
      course: [],
      season: [],
      showModal: false,
      tmparams: [],
      reports: [],
      homeSectionData:[]
    };
  },
  computed: {
    banner: function(ban) {
      if (this.$route.name === "home") ban = "2021/03/Tartan_Main_Home_2.jpg";
      else if (this.$route.name === "contact") ban = "2021/03/contact_BG.png";
      else ban = "2021/03/headerbar.png";
      return ban;
    },

    reportTitle: function(url) {
      if (this.currentReport.indexOf("tmentry") !== -1) {
        url =
          this.config.VUE_APP_APIFULL_URL +
          this.tm_params.tm_params.season_code +
          "/" +
          this.tm_params.tm_params.season_code +
          "-" +
          this.course +
          "-entry-entries.json?randomadd=" +
          new Date().getTime();
      } else {
        if (this.currentReport.indexOf("tmscore") !== -1) {
          var subRep2 = this.currentReport.lastIndexOf("params=") + 7;
          var indNext2 = this.currentReport.indexOf("~", subRep2);
          var repParams = this.currentReport.substr(
            subRep2,
            indNext2 - subRep2
          );

          if (repParams && repParams.indexOf(".cgi") < 0) {
            url =
              this.config.VUE_APP_API +
              this.config.VUE_APP_ID +
              "/cache/" +
              this.config.VUE_APP_ID +
              "/" +
              this.season +
              "/" +
              this.season +
              "-" +
              this.course +
              "-scores-" +
              repParams +
              ".json" +
              "?randomadd=" +
              new Date().getTime();
            // var url = "http://dev-auspga.ocs-software.com/api/" + "dev" + "/cache/" + "dev" + "/" + "215S" + "/" + "215S" + "-" + "AUS7" + "-scores-" + $scope.repParams + ".json"+"?randomadd=1603894106415";
          } else {
            url =
              this.config.VUE_APP_API +
              this.config.VUE_APP_ID +
              "/cache/" +
              this.config.VUE_APP_ID +
              "/" +
              this.season +
              "/" +
              this.season +
              "-" +
              this.course +
              "-scores-latest.json" +
              "?gt=y&randomadd=" +
              new Date().getTime();
            // var url = "http://dev-auspga.ocs-software.com/api/dev/cache/dev/215S/215S-AUS7-scores-latest.json?gt=y&randomadd=1573131881374"
          }
        } else if (this.currentReport.indexOf("tmlsmon") !== -1) {
          {
            url =
              this.config.VUE_APP_API +
              this.config.VUE_APP_ID +
              "/cache/" +
              this.config.VUE_APP_ID +
              "/" +
              this.season +
              "/" +
              this.season +
              "-" +
              this.course +
              "-scores-latest.json" +
              "?gt=y&randomadd=" +
              new Date().getTime();
            // var url = "http://dev-auspga.ocs-software.com/api/dev/cache/dev/215S/215S-AUS7-scores-latest.json?gt=y&randomadd=1573131881374"
          }
        } else if (this.currentReport.indexOf("tmdraw") !== -1) {
          var subRep = this.currentReport.lastIndexOf("round=") + 6;
          var indNext = this.currentReport.indexOf("~", subRep);
          var drawRnd = this.currentReport.substr(subRep, indNext - subRep);
          url =
            this.config.VUE_APP_API +
            this.config.VUE_APP_ID +
            "/cache/" +
            this.config.VUE_APP_ID +
            "/" +
            this.season +
            "/" +
            this.season +
            "-" +
            this.course +
            "-draw-R" +
            drawRnd +
            "-draw.json" +
            "?randomadd=" +
            new Date().getTime();
        } else if (this.currentReport.indexOf("tmresult") !== -1) {
          var subRep1 = this.currentReport.lastIndexOf("result=") + 7;
          var indNext1 = this.currentReport.indexOf("~", subRep1);
          var resNum1 = this.currentReport.substr(subRep1, indNext1 - subRep1);
          console.log("resNum === ");
          console.log(resNum1);
          url =
            this.config.VUE_APP_API +
            this.config.VUE_APP_ID +
            "/cache/" +
            this.config.VUE_APP_ID +
            "/" +
            this.season +
            "/" +
            this.season +
            "-" +
            this.course +
            "-result-result-" +
            resNum1 +
            ".json" +
            "?randomadd=" +
            new Date().getTime();
        } else {
          url =
            this.config.VUE_APP_API +
            this.config.VUE_APP_ID +
            "/cache/" +
            this.config.VUE_APP_ID +
            "/" +
            this.season +
            "/" +
            this.season +
            "-" +
            this.course +
            "-result-result-PF.json" +
            "?randomadd=" +
            new Date().getTime();
        }
      }
      return url;
    },
  },
  created() {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      sessionStorage.setItem("showModal", "yes");
    } else {
      sessionStorage.setItem("showModal", "no");
    }
  },
  methods: {
    show() {
      this.showModal = true;
      this.$emit("show-me");
    },
    close() {
      this.showModal = false;
      sessionStorage.setItem("showModal", "no");
      this.$emit("hide-me");
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    currentReport() {
      if (Array.isArray(this.reports))
        return this.reports[this.reports.length - 1].report_url;
      else return this.reports.report_url;
    },
    currentTitle() {
      if (Array.isArray(this.reports))
        return this.reports[this.reports.length - 1].report_title;
      else return this.reports.report_title;
    },
    HomeSection: function() {
        axios.get(
        "https://wp-tpt.ocs-sport.com/index.php/wp-json/wp/v2/HomeSection?randomadd=" +
        new Date().getTime()
        )
        .then(response => {
          this.homeSectionData = response.data[0].acf;
          console.log("this.homeSectionData")
          console.log(this.homeSectionData)
        })  
    }
  },
  mounted() {
    this.HomeSection();
    const showModal = sessionStorage.getItem("showModal");
    console.log(showModal);
    if (showModal === "yes") setTimeout(() => this.$refs.myModal.show(), 3500);
        apiCall 
      .tmParamsBase()
      .then(({ data }) => {
        this.course = data.code;
        this.okfound = data.ok_found;
        this.tmparams = data;
        this.reports = data.reports.reports_entry;
        this.season = data.tm_params.season_code;
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
        throw error;
      });
  },
};
</script>

<style scoped>
.bannerImg.NonBanner.contactBanner {
  position: relative;
  background-image: url(https://ocs-sport.ams3.cdn.digitaloceanspaces.com/tartanprotour/2024/04/TartanTour_V1.png) !important;
  background-size: cover;
}
.bannerImg.NonBanner {
  position: relative;
  background-image: url(https://ocs-sport.ams3.cdn.digitaloceanspaces.com/tartanprotour/2024/04/TartanPro_2023Header_V2.png) !important;
  background-size: cover;
}
.NonBanner {
  background-image: none;
  background-color: #1A2337;
}
.router-link-exact-active {
  color: #CC444A !important;
}
.navbar-dark .navbar-nav .nav-link:hover,
.navbar-dark .navbar-nav .nav-link:focus,
.navbar-dark .navbar-nav .nav-link:active {
  color: #CC444A;
  padding: 0 19px 0 19px;
  font-size: 0.95rem;
}
::v-deep .modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
  background-image: url(https://ocs-sport.ams3.cdn.digitaloceanspaces.com/tartanprotour/2021/03/Mobile_Navdrawer_BG.png) !important;
}
::v-deep div#modal-1___BV_modal_content_ {
  background-image: url(https://ocs-sport.ams3.cdn.digitaloceanspaces.com/tartanprotour/2021/03/Mobile_Navdrawer_BG.png) !important;
}
::v-deep .modal-content {
  background-image: url(https://ocs-sport.ams3.cdn.digitaloceanspaces.com/tartanprotour/2021/03/Mobile_Navdrawer_BG.png) !important;
}
h2.dLoad {
  font-size: 23pt;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
}
li {
  list-style: none;
}
.dLoadImg {
  width: 225px;
}
.downloadLinks {
  text-align: center;
}
img.appStore {
  width: 200px;
  text-align: center;
}
.Downloadbox {
  text-align: center;
}
.navbar-dark .navbar-nav .nav-link {
  color: #fff;
  padding: 0 19px 0 19px;
  font-size: 0.95rem;
}
.navbar-dark .navbar-nav .nav-link:hover,
.navbar-dark .navbar-nav .nav-link:focus {
  color: #CC444A;
  padding: 0 19px 0 19px;
  font-size: 0.95rem;
}
.bannerImg {
  background-repeat: no-repeat;
  background-position-y: top;
  background-size: cover;
  display: block;
  position: relative;
  width: 100%;
  height: calc(35vh + 35vw);
  background-position-x: right;
  box-shadow: 0 0.5rem 1rem rgb(0 0 0 / 5%), inset 0 -1px 0 rgb(0 0 0 / 10%);
  background-attachment: inherit;
  margin-bottom: 0;
}
.bannerTitle {
  padding: 10% 0 0 10%;
  color: white;
}
.homeGolf {
  padding: 2% 0;
  color: #CC444A;
  font-style: italic;
}
::v-deep .bannerTitle > button {
  background-color: transparent;
  border-color: white;
  font-size: 1.5rem;
  border-radius: 0;
  padding: 1% 7%;
  border: 2px solid;
}
::v-deep .bannerTitle > a.btn {
  background-color: transparent;
  border-color: white;
  font-size: 1.5rem;
  border-radius: 0;
  padding: 1% 7%;
  border: 2px solid!important;
  margin-top: 10px;
}
::v-deep .bannerTitle > a.btn:hover {
  background-color: #CC444A;
  border-color: white;
  font-size: 1.5rem;
  border-radius: 0;
  padding: 1% 7%;
  border: 2px solid;
  margin-top: 10px;
}
.logoImg {
  width: 200px;
  margin-top: 5px;
  margin-bottom: -25px;
  margin-left: 10%;
  margin-bottom: 5px !important;
}
::v-deep .svg-inline--fa {
  font-size: 1.5rem;
}
@media only screen and (max-width: 768px) {
  .cont > a {
    padding-left: 0;
    padding-right: 0;
  }
  .bannerTitle > h1 {
    font-size: 1.5rem;
  }
  .mobileMenu {
    background-image: url(https://ocs-sport.ams3.cdn.digitaloceanspaces.com/tartanprotour/2021/03/Mobile_Navdrawer_BG.png);
    border: 0px solid rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background-repeat: no-repeat;
    background-size: cover;
    position: absolute;
    padding: 0;
    top: -30px;
    left: -149px;
    height: 102vh;
    background-position-y: bottom;
  }
  .menuGroup {
    padding: 10vh 61vw;
  }
  .nav-link {
    color: white;
    font-size: 20pt;
    line-height: 2rem;
    font-weight: 100;
    text-align: center;
  }
  ::v-deep #modal-1___BV_modal_content_ {
    background-image: url(https://ocs-sport.ams3.cdn.digitaloceanspaces.com/tartanprotour/2021/03/Mobile_Navdrawer_BG.png);
    background-repeat: no-repeat;
    background-size: cover;
    color: white;
    text-align: center;
    border-radius: 10px;
  }
  .appStore {
    width: 100%;
  }
  .dLoad {
    font-size: 1.5rem;
    text-align: center;
    padding: 50px 0;
  }
  .nav-item {
    margin: 20px;
  }
  .closeBtn{
    color: white;
    z-index: 9999;
    position: absolute;
    background: transparent;
    border: 0;
    right: 0;
  }
}
@media only screen and (max-width: 480px) {
  .logoImg {
    width: 150px;
  }
}
</style>
